import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=f5bb8ca0&scoped=true"
import script from "./NotificationBell.vue?vue&type=script&lang=js"
export * from "./NotificationBell.vue?vue&type=script&lang=js"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=f5bb8ca0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bb8ca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5bb8ca0')) {
      api.createRecord('f5bb8ca0', component.options)
    } else {
      api.reload('f5bb8ca0', component.options)
    }
    module.hot.accept("./NotificationBell.vue?vue&type=template&id=f5bb8ca0&scoped=true", function () {
      api.rerender('f5bb8ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/notification/NotificationBell.vue"
export default component.exports